import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink, useNavigate } from "react-router-dom";
import {
    FiCheck,
    FiX,
    FiDownload,
    FiCreditCard,
    FiCalendar,
    FiRefreshCw,
    FiAlertCircle,
    FiStar,
    FiZap,
    FiFileText,
    FiClock,
} from "react-icons/fi";

// Format number in Indian Rupees
const formatINR = (amount) => {
    const numAmount = typeof amount === "number" ? amount : parseFloat(amount) || 0;
    return `₹${Number(numAmount.toFixed(0)).toLocaleString("en-IN")}`;
};

// Format date
const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

export default function PlansBilling() {
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showCompare, setShowCompare] = useState(false);
    const [activeTab, setActiveTab] = useState("plans"); // plans, invoices

    // Static Data - Subscription Plans
    const plans = [
        {
            id: 1,
            name: "Free",
            price: 0,
            period: "month",
            description: "Basic access to research content",
            features: [
                "Limited research articles",
                "Basic market analysis",
                "Email support",
                "Free reports (watermarked)",
            ],
            notIncluded: [
                "Premium research reports",
                "Expert analyst calls",
                "Model portfolio",
                "Priority alerts",
            ],
            popular: false,
            currentPlan: true,
        },
        {
            id: 2,
            name: "Basic",
            price: 499,
            period: "month",
            description: "Enhanced research access",
            features: [
                "All research articles",
                "Premium market analysis",
                "Email & chat support",
                "Downloadable reports",
                "Basic analyst calls",
            ],
            notIncluded: [
                "Model portfolio",
                "Priority alerts",
                "Dedicated advisor",
            ],
            popular: true,
            currentPlan: false,
        },
        {
            id: 3,
            name: "Premium",
            price: 1499,
            period: "month",
            description: "Complete research suite",
            features: [
                "All Basic features",
                "Model portfolio allocations",
                "Expert analyst calls",
                "Priority alerts & notifications",
                "Dedicated advisor support",
                "Advanced analytics",
                "Custom research requests",
            ],
            notIncluded: [],
            popular: false,
            currentPlan: false,
        },
    ];

    // Static Data - Invoices
    const invoices = [
        {
            id: 1,
            invoiceNo: "INV-2024-001",
            planName: "Basic Plan",
            amount: 499,
            date: "2024-01-15",
            dueDate: "2024-01-15",
            status: "Paid",
            paymentMethod: "Credit Card",
            downloadUrl: "#",
            autoRenew: true,
            nextRenewal: "2024-02-15",
        },
        {
            id: 2,
            invoiceNo: "INV-2023-045",
            planName: "Basic Plan",
            amount: 499,
            date: "2023-12-15",
            dueDate: "2023-12-15",
            status: "Paid",
            paymentMethod: "Credit Card",
            downloadUrl: "#",
            autoRenew: true,
            nextRenewal: "2024-01-15",
        },
        {
            id: 3,
            invoiceNo: "INV-2023-032",
            planName: "Premium Plan",
            amount: 1499,
            date: "2023-11-15",
            dueDate: "2023-11-15",
            status: "Failed",
            paymentMethod: "Credit Card",
            downloadUrl: "#",
            autoRenew: true,
            nextRenewal: "2023-12-15",
        },
        {
            id: 4,
            invoiceNo: "INV-2023-028",
            planName: "Basic Plan",
            amount: 499,
            date: "2023-10-15",
            dueDate: "2023-10-15",
            status: "Paid",
            paymentMethod: "UPI",
            downloadUrl: "#",
            autoRenew: false,
            nextRenewal: null,
        },
    ];

    const handlePurchase = (plan) => {
        setSelectedPlan(plan);
        alert(`Redirecting to payment for ${plan.name} Plan...`);
        // Navigate to payment page
    };

    const handleRenew = (invoice) => {
        alert(`Renewing ${invoice.planName}...`);
    };

    const handleDownloadInvoice = (invoice) => {
        alert(`Downloading invoice ${invoice.invoiceNo}...`);
    };

    const handleCancelAutoRenew = (invoice) => {
        if (window.confirm("Are you sure you want to cancel auto-renewal?")) {
            alert(`Auto-renewal cancelled for ${invoice.planName}`);
        }
    };

    const handleComparePlans = () => {
        setShowCompare(!showCompare);
    };

    return (
        <>
            <ClientNavbar />
            <div className="page-content" style={{ background: "#f8fafc" }}>
            <style>{`
                .plan-card {
                    transition: all 0.3s ease;
                    border: 1px solid #e9ecef;
                }
                .plan-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 20px rgba(0,0,0,0.1) !important;
                    border-color: #1bafb4;
                }
                .tab-button {
                    transition: all 0.2s ease;
                    border-radius: 8px 8px 0 0;
                }
                .tab-button:hover {
                    background-color: #f1f5f9;
                }
                .tab-button.active {
                    background-color: #1bafb4;
                    color: white;
                    border-color: #1bafb4;
                }
            `}</style>
                    {/* Header */}
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div>

                                <h3 className="text-primary mb-2">Plans & Billing</h3>
                                <nav
                                    aria-label="breadcrumb"
                                    style={{ "--bs-breadcrumb-divider": "none" }}
                                >
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                        <NavLink to="/overview">Dashboard</NavLink> /
                                        </li>
                                        <li className="breadcrumb-item">
                                        
                                            <NavLink to="/overview">Research Analysis</NavLink> /
                                        </li>
                                        <li className="breadcrumb-item active">Plans & Billing</li>
                                    </ol>
                                </nav>
                                </div>
                                {activeTab === "plans" && (
                                    <div className="d-flex gap-2 align-items-center flex-wrap mt-2">
                                        <button
                                            className="btn btn-primary btn-sm fw-semibold"
                                            onClick={handleComparePlans}
                                            style={{ borderRadius: "8px" }}
                                        >
                                            {showCompare ? "Hide Compare" : "Compare Plans"}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    

                    {/* Tabs */}
                    <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                        <div className="card-body p-0">
                            <ul className="nav d-flex  nav-tabs border-0 px-3 pt-3">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link tab-button ${activeTab === "plans" ? "active" : ""}`}
                                        onClick={() => setActiveTab("plans")}
                                        style={{
                                            border: "none",
                                            padding: "12px 20px",
                                            fontWeight: activeTab === "plans" ? "600" : "500",
                                        }}
                                    >
                                        <FiStar className="me-2" />
                                        Plans
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link tab-button ${activeTab === "invoices" ? "active" : ""}`}
                                        onClick={() => setActiveTab("invoices")}
                                        style={{
                                            border: "none",
                                            padding: "12px 20px",
                                            fontWeight: activeTab === "invoices" ? "600" : "500",
                                        }}
                                    >
                                        <FiFileText className="me-2" />
                                        Invoices
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Plans Tab */}
                    {activeTab === "plans" && (
                        <>
                            {/* Compare Plans View */}
                            {showCompare && (
                                <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                                    <div
                                        className="card-header border-0 d-flex justify-content-between align-items-center py-3 px-4"
                                        style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}
                                    >
                                        <h5 className="mb-0 fw-bold text-dark">Compare Plans</h5>
                                    </div>
                                    <div className="card-body p-0">
                                        <div className="table-responsive">
                                            <table className="table table-bordered mb-0 align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th style={{ width: "25%", padding: "20px" }} className="fw-bold">
                                                            Features
                                                        </th>
                                                        {plans.map((plan) => (
                                                            <th
                                                                key={plan.id}
                                                                className="text-center"
                                                                style={{ width: "25%", padding: "20px" }}
                                                            >
                                                                <div>
                                                                    <h6 className="mb-2 fw-bold">{plan.name}</h6>
                                                                    <div className="text-primary fw-bold" style={{ fontSize: "18px" }}>
                                                                        {plan.price === 0 ? "Free" : formatINR(plan.price)}
                                                                        {plan.price > 0 && (
                                                                            <small className="text-muted" style={{ fontSize: "12px" }}>
                                                                                /month
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                    {plan.popular && (
                                                                        <span
                                                                            className="badge mt-2"
                                                                            style={{
                                                                                background: "linear-gradient(135deg, #1bafb4 0%, #06b6a4 100%)",
                                                                                fontSize: "10px",
                                                                            }}
                                                                        >
                                                                            Most Popular
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Research Articles
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <span className="text-muted">Limited</span>
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Premium Reports
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Analyst Calls
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <span className="text-muted">Basic</span>
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Model Portfolio
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Priority Alerts
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiX className="text-danger" style={{ fontSize: "20px" }} />
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <FiCheck className="text-success" style={{ fontSize: "20px" }} />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-semibold" style={{ padding: "16px 20px" }}>
                                                            Support
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <span className="text-muted">Email</span>
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <span className="text-muted">Email & Chat</span>
                                                        </td>
                                                        <td className="text-center" style={{ padding: "16px" }}>
                                                            <span className="text-muted">Dedicated Advisor</span>
                                                        </td>
                                                    </tr>
                                                    <tr style={{ background: "#f8fafc" }}>
                                                        <td style={{ padding: "20px" }}></td>
                                                        {plans.map((plan) => (
                                                            <td key={plan.id} className="text-center" style={{ padding: "20px" }}>
                                                                {plan.currentPlan ? (
                                                                    <span className="badge bg-success px-3 py-2">
                                                                        Current Plan
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-primary btn-sm w-100"
                                                                        onClick={() => handlePurchase(plan)}
                                                                        style={{ borderRadius: "8px" }}
                                                                    >
                                                                        {plan.price === 0 ? "Get Started" : "Purchase"}
                                                                    </button>
                                                                )}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Plan Cards */}
                            {!showCompare && (
                                <div className="row g-4 mb-4">
                                    {plans.map((plan) => (
                                        <div key={plan.id} className="col-lg-4 col-md-6">
                                            <div
                                                className={`card h-100 plan-card position-relative border-0 ${plan.popular ? "border-primary border-2" : ""}`}
                                                style={{ borderRadius: "12px" }}
                                            >
                                                {plan.popular && (
                                                    <div
                                                        className="position-absolute top-0 start-50 translate-middle"
                                                        style={{ marginTop: "-12px", zIndex: 10 }}
                                                    >
                                                        <span
                                                            className="badge px-3 py-2 fw-semibold"
                                                            style={{
                                                                background: "linear-gradient(135deg, #1bafb4 0%, #06b6a4 100%)",
                                                                fontSize: "11px",
                                                                color: "white",
                                                            }}
                                                        >
                                                            <FiStar className="me-1" />
                                                            Most Popular
                                                        </span>
                                                    </div>
                                                )}
                                                {plan.currentPlan && (
                                                    <div className="position-absolute top-0 end-0 m-3" style={{ zIndex: 10 }}>
                                                        <span className="badge bg-success px-3 py-2 fw-semibold">
                                                            Current Plan
                                                        </span>
                                                    </div>
                                                )}
                                                <div className="card-body p-4">
                                                    <div className="text-center mb-4">
                                                        <h4 className="text-primary fw-bold mb-3" style={{ fontSize: "24px" }}>
                                                            {plan.name}
                                                        </h4>
                                                        <div className="mb-3">
                                                            <span className="h2 text-dark fw-bold" style={{ fontSize: "36px" }}>
                                                                {plan.price === 0 ? "Free" : formatINR(plan.price)}
                                                            </span>
                                                            {plan.price > 0 && (
                                                                <span className="text-muted ms-1" style={{ fontSize: "16px" }}>
                                                                    /month
                                                                </span>
                                                            )}
                                                        </div>
                                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                                                            {plan.description}
                                                        </p>
                                                    </div>

                                                    <div className="mb-4">
                                                        <h6 className="fw-bold mb-3" style={{ fontSize: "15px" }}>
                                                            Features Included:
                                                        </h6>
                                                        <ul className="list-unstyled mb-0">
                                                            {plan.features.map((feature, index) => (
                                                                <li key={index} className="mb-2 d-flex align-items-start">
                                                                    <FiCheck
                                                                        className="me-2 text-success mt-1"
                                                                        style={{ minWidth: "20px", fontSize: "18px" }}
                                                                    />
                                                                    <span style={{ fontSize: "14px", lineHeight: "1.6" }}>
                                                                        {feature}
                                                                    </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>

                                                    {plan.notIncluded.length > 0 && (
                                                        <div className="mb-4">
                                                            <h6 className="fw-semibold mb-3 text-muted" style={{ fontSize: "15px" }}>
                                                                Not Included:
                                                            </h6>
                                                            <ul className="list-unstyled mb-0">
                                                                {plan.notIncluded.map((feature, index) => (
                                                                    <li key={index} className="mb-2 d-flex align-items-start">
                                                                        <FiX
                                                                            className="me-2 text-danger mt-1"
                                                                            style={{ minWidth: "20px", fontSize: "18px" }}
                                                                        />
                                                                        <span
                                                                            className="text-muted"
                                                                            style={{ fontSize: "14px", lineHeight: "1.6" }}
                                                                        >
                                                                            {feature}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}

                                                    <div className="mt-auto pt-3">
                                                        {plan.currentPlan ? (
                                                            <button
                                                                className="btn btn-primary w-100"
                                                                disabled
                                                                style={{ borderRadius: "8px", padding: "12px" }}
                                                            >
                                                                Current Plan
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className={`btn btn-primary w-100 ${plan.popular ? "btn-primary" : "btn-outline-primary"}`}
                                                                onClick={() => handlePurchase(plan)}
                                                                style={{
                                                                    borderRadius: "8px",
                                                                    padding: "12px",
                                                                    fontSize: "15px",
                                                                }}
                                                            >
                                                                {plan.price === 0 ? "Get Started" : "Purchase Plan"}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Payment Info */}
                            <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                                <div
                                    className="card-header border-0 d-flex align-items-center py-3 px-4"
                                    style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}
                                >
                                    <div
                                        className="me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "10px",
                                            background: "#c8eeecbf",
                                        }}
                                    >
                                        <FiCreditCard style={{ color: "#39b2b4", fontSize: "20px" }} />
                                    </div>
                                    <h5 className="mb-0 fw-bold text-dark">Payment Information</h5>
                                </div>
                                <div className="card-body p-4">
                                    <div className="alert alert-info mb-0 border-0" style={{ borderRadius: "8px" }}>
                                        <div className="d-flex align-items-start">
                                            <FiAlertCircle className="me-3 mt-1" style={{ fontSize: "20px", minWidth: "24px" }} />
                                            <div>
                                                <strong className="d-block mb-2">Payment Processing:</strong>
                                                <ul className="mb-0" style={{ paddingLeft: "20px" }}>
                                                    <li className="mb-2">Payments are verified via secure webhook integration</li>
                                                    <li className="mb-2">Refunds are processed according to our refund policy</li>
                                                    <li className="mb-2">You will receive renewal reminders before your plan expires</li>
                                                    <li>Payment success/failure notifications will be sent via email</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {/* Invoices Tab */}
                    {activeTab === "invoices" && (
                        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", overflow: "hidden" }}>
                            <div
                                className="card-header border-0 d-flex justify-content-between align-items-center py-3 px-4"
                                style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}
                            >
                                <div className="d-flex align-items-center">
                                    <div
                                        className="me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "40px",
                                            height: "40px",
                                            borderRadius: "10px",
                                            background: "#c8eeecbf",
                                        }}
                                    >
                                        <FiFileText style={{ color: "#39b2b4", fontSize: "20px" }} />
                                    </div>
                                    <h5 className="mb-0 fw-bold text-dark">Invoice History</h5>
                                </div>
                                <span
                                    className="badge px-3 py-2"
                                    style={{
                                        background: "linear-gradient(135deg, #1bafb4 0%, #06b6a4 100%)",
                                        fontSize: "12px",
                                    }}
                                >
                                    {invoices.length} Invoices
                                </span>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0 align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Invoice No
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Plan
                                                </th>
                                                <th className="text-end fw-semibold" style={{ padding: "16px 20px" }}>
                                                    Amount
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Date
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Due Date
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Status
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Payment Method
                                                </th>
                                                <th style={{ padding: "16px 20px" }} className="fw-semibold">
                                                    Auto Renew
                                                </th>
                                                <th className="text-center fw-semibold" style={{ padding: "16px 20px" }}>
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoices.map((invoice) => (
                                                <tr key={invoice.id}>
                                                    <td style={{ padding: "16px 20px" }}>
                                                        <strong>{invoice.invoiceNo}</strong>
                                                    </td>
                                                    <td style={{ padding: "16px 20px" }}>{invoice.planName}</td>
                                                    <td className="text-end fw-semibold" style={{ padding: "16px 20px" }}>
                                                        {formatINR(invoice.amount)}
                                                    </td>
                                                    <td style={{ padding: "16px 20px" }}>{formatDate(invoice.date)}</td>
                                                    <td style={{ padding: "16px 20px" }}>{formatDate(invoice.dueDate)}</td>
                                                    <td style={{ padding: "16px 20px" }}>
                                                        <span
                                                            className={`badge px-3 py-2 ${invoice.status === "Paid"
                                                                ? "bg-success"
                                                                : invoice.status === "Failed"
                                                                    ? "bg-danger"
                                                                    : "bg-warning"
                                                                }`}
                                                        >
                                                            {invoice.status}
                                                        </span>
                                                    </td>
                                                    <td style={{ padding: "16px 20px" }}>
                                                        <small className="text-muted">{invoice.paymentMethod}</small>
                                                    </td>
                                                    <td style={{ padding: "16px 20px" }}>
                                                        {invoice.autoRenew ? (
                                                            <div>
                                                                <span className="badge bg-info me-2">Active</span>
                                                                {invoice.nextRenewal && (
                                                                    <small className="text-muted d-block mt-1" style={{ fontSize: "11px" }}>
                                                                        Renews: {formatDate(invoice.nextRenewal)}
                                                                    </small>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <span className="badge bg-secondary">Disabled</span>
                                                        )}
                                                    </td>
                                                    <td className="text-center" style={{ padding: "16px 20px" }}>
                                                        <div className="d-flex gap-2 justify-content-center flex-wrap">
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                onClick={() => handleDownloadInvoice(invoice)}
                                                                title="Download Invoice"
                                                                style={{ borderRadius: "6px" }}
                                                            >
                                                                <FiDownload />
                                                            </button>
                                                            {invoice.status === "Paid" && invoice.autoRenew && (
                                                                <button
                                                                    className="btn btn-sm btn-outline-warning"
                                                                    onClick={() => handleCancelAutoRenew(invoice)}
                                                                    title="Cancel Auto-Renewal"
                                                                    style={{ borderRadius: "6px" }}
                                                                >
                                                                    <FiX />
                                                                </button>
                                                            )}
                                                            {invoice.status === "Failed" && (
                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => handleRenew(invoice)}
                                                                    title="Retry Payment"
                                                                    style={{ borderRadius: "6px" }}
                                                                >
                                                                    <FiRefreshCw />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Renewal Reminders Section */}
                    {activeTab === "invoices" && (
                        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                            <div
                                className="card-header border-0 d-flex align-items-center py-3 px-4"
                                style={{ background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}
                            >
                                <div
                                    className="me-3 d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "10px",
                                        background: "#c8eeecbf",
                                    }}
                                >
                                    <FiClock style={{ color: "#39b2b4", fontSize: "20px" }} />
                                </div>
                                <h5 className="mb-0 fw-bold text-dark">Upcoming Renewals</h5>
                            </div>
                            <div className="card-body p-4">
                                {invoices
                                    .filter((inv) => inv.autoRenew && inv.status === "Paid" && inv.nextRenewal)
                                    .map((invoice) => (
                                        <div
                                            key={invoice.id}
                                            className="alert alert-info d-flex justify-content-between align-items-center mb-3 border-0"
                                            style={{ borderRadius: "8px" }}
                                        >
                                            <div>
                                                <strong className="d-block mb-1">{invoice.planName}</strong>
                                                <div className="mb-2">
                                                    Will renew on <strong>{formatDate(invoice.nextRenewal)}</strong>
                                                </div>
                                                <div className="small text-muted">
                                                    Amount: {formatINR(invoice.amount)} | Payment Method:{" "}
                                                    {invoice.paymentMethod}
                                                </div>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-outline-warning fw-semibold"
                                                onClick={() => handleCancelAutoRenew(invoice)}
                                                style={{ borderRadius: "8px", whiteSpace: "nowrap" }}
                                            >
                                                Cancel Renewal
                                            </button>
                                        </div>
                                    ))}
                                {invoices.filter(
                                    (inv) => inv.autoRenew && inv.status === "Paid" && inv.nextRenewal
                                ).length === 0 && (
                                        <p className="text-muted mb-0 text-center py-3">No upcoming renewals</p>
                                    )}
                            </div>
                        </div>
                    )}
                </div>
        </>
    );
}
